/* ---- Be Neo MindMag — caixa de compra da sub5 ----------------------------
   Fork de `brainmag-sub4.js`, feito em 06-07/10/2026. A sub4 segue no ar com o
   arquivo original, intocado: as duas nunca renderizam juntas.

   A logica de compra e a da sub4:
     - sem checkbox: com selling plan na variante, o botao vende a assinatura;
     - o RISCADO do card e do botao e o preco de COMPRA UNICA da mesma
       quantidade, e o "Save %" e o da assinatura sobre o avulso;
     - compra unica pelo link "Buy once - no free gifts", sem plano;
     - sem selling plan, a pagina vende so compra unica e o link some.

   O que muda:
     - o item leva `_pagina: sub5`;
     - BRINDES (so assinando): linhas de US$ 0 SEM selling plan, adicionadas no
       mesmo `adicionar([...])` do pack. O `carrinhoSubstitui` confere o
       carrinho contra a lista inteira (pack + brindes), entao "voltar" e
       clique duplo nao duplicam nada. Sem plano, nao ha brinde nenhum;
     - caixa "You're saving $X on this order" = (avulso + frete do avulso) -
       (assinatura + frete da assinatura) + valor dos brindes;
     - frete: a assinatura le o `ship` do `#lp-offer-data`, o avulso o do
       `#lp-once-data` — cada um com o mapa dele;
     - propriedades do pack (ocultas): "_you_save" e "_guarantee"; do brinde: "Free gift"
       com o valor (e a nota, que diz como chega);
     - 07/10/2026: cards empilhados no modelo da SP. Cada card monta o titulo
       ("Get 3 Bottles + 2 Free Gifts") e as linhas de beneficio (brindes com
       foto e valor riscado, frete, garantia). A caixa separada de brindes e
       os chips sairam.

   Galeria, contador e o viewcontent do RedTrack sao copia literal da sub4 —
   `tests/sub5.test.js` trava isso.
   -------------------------------------------------------------------------- */
(function () {
  var D = {};                    /* qty -> assinatura {variantId, price, ship, avail, plan} */
  var O = {};                    /* qty -> compra unica {variantId, once, ship, avail} */
  var G = [];                    /* brindes {variantId, name, short, note, value, minQty, img} */
  var QTYS = [];
  var qty = 0;
  var sub = true;                /* sem caixa: vira false so se a loja nao tiver plano */
  var PAGINA = 'sub5';           /* vai no item como `_pagina`; a section pode trocar (sub6, sub7) */
  /* Modelo SP (sub7, 07/10/2026) — tudo vem de data-attributes do container,
     e o padrao e o comportamento da sub5: */
  var GARANTIA = { 1: 90, 2: 90, 3: 90 };  /* dias de garantia por pack */
  var SUPPLY = false;            /* subtitulo "N Month(s) Supply" */
  var ANCORA = 'avulso';         /* 'compare': riscado/economia pelo compare_at */
  var SEM_FRETE_PAGO = false;    /* esconde a linha de frete do card quando e pago */
  /* Unidade do pack (13/10/2026, Gummies vem em pouch): a pagina pode publicar
     #mm-unidade {"one":"Pouch","many":"Pouches"}; sem ele, segue "Bottle". */
  var UN1 = 'Bottle', UNN = 'Bottles';
  var SEM_FRETE_GRATIS = false;  /* frete pago vira a linha "No Free Shipping" (modelo SP) */

  /* Na moeda do visitante (Markets): '$' nos EUA, '£' no Reino Unido. O valor
     ja vem convertido pelo Liquid; aqui so troca o simbolo. */
  function usd(n) {
    var c = window.Shopify && Shopify.currency && Shopify.currency.active;
    return ({ GBP: '£', EUR: '€' }[c] || '$') + n.toFixed(2);
  }
  function cents(n) { return Math.round(n * 100) / 100; }

  function lerJson(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function read() {
    var a = lerJson('lp-offer-data');
    if (!a || !a.items || !a.items.length) return false;
    a.items.forEach(function (it) {
      if (!it.qty) return;
      D[it.qty] = {
        variantId: it.variantId,
        price: (it.plan && it.plan.price != null ? it.plan.price : it.oncePrice) / 100,
        compare: it.comparePrice ? it.comparePrice / 100 : null,
        ship: parseFloat(it.ship) || 0,
        avail: it.available !== false,
        plan: it.plan || null
      };
      QTYS.push(it.qty);
    });
    var b = lerJson('lp-once-data');
    if (b && b.items) {
      b.items.forEach(function (it) {
        if (!it.qty) return;
        O[it.qty] = {
          variantId: it.variantId,
          once: it.oncePrice / 100,
          compare: it.comparePrice ? it.comparePrice / 100 : null,
          ship: parseFloat(it.ship) || 0,
          avail: it.available !== false
        };
      });
    }
    var g = lerJson('lp-gift-data');
    if (g && g.items) {
      g.items.forEach(function (it) {
        if (!it || !it.variantId) return;
        G.push({
          variantId: it.variantId,
          name: it.name || '',
          short: it.short || it.name || '',
          note: it.note || '',
          value: (it.value || 0) / 100,
          minQty: it.minQty || 99,
          img: it.img || ''
        });
      });
    }
    return QTYS.length > 0;
  }

  function temPlano() {
    return QTYS.some(function (q) { return D[q] && D[q].plan && D[q].plan.id; });
  }
  /* Modo assinatura de verdade: ha plano na loja E a variante tem plano. */
  function modoSub() { return sub && !!(D[qty] && D[qty].plan && D[qty].plan.id); }
  /* Preco avulso da quantidade. Sem o produto de compra unica na pagina, cai no
     proprio preco da assinatura — a pagina nunca fica sem preco. */
  function avulso(q) { return O[q] ? O[q].once : (D[q] ? D[q].price : 0); }
  /* Assinando? Entao o card e do produto de assinatura; senao, do avulso. */
  function subDe(q) { return sub && D[q] && D[q].plan; }
  /* O card mostra o preco que se paga: o de assinante quando ha plano. */
  function precoCard(q) { return precoPago(q); }
  function precoPago(q) { return subDe(q) ? D[q].price : avulso(q); }
  /* O RISCADO, assinando, e o preco de COMPRA UNICA da mesma quantidade. Sem
     plano, cai no compare_at. Uma ancora por card, e o mesmo numero no botao. */
  function riscadoDe(q) {
    if (ANCORA === 'compare') return ((subDe(q) ? D[q] && D[q].compare : O[q] && O[q].compare) || 0);
    if (subDe(q) && O[q]) return O[q].once;
    return ((O[q] && O[q].compare) || (D[q] && D[q].compare) || 0);
  }
  function ativo(q) { return (sub && D[q] && D[q].plan) ? D[q] : (O[q] || D[q]); }

  /* Brindes do pack: so assinando, e so os que o pack alcanca. */
  function brindesDe(q) {
    if (!subDe(q)) return [];
    return G.filter(function (g) { return q >= g.minQty; });
  }
  /* Economia do PACK contra comprar o mesmo avulso, frete incluido. */
  function economiaPack(q) {
    if (ANCORA === 'compare') return subDe(q) && D[q].compare > D[q].price ? cents(D[q].compare - D[q].price) : 0;
    if (!subDe(q) || !O[q]) return 0;
    return cents((O[q].once + O[q].ship) - (D[q].price + D[q].ship));
  }
  /* A caixa "You're saving": pack + valor dos brindes. */
  function economiaTotal(q) {
    var t = economiaPack(q);
    brindesDe(q).forEach(function (g) { t += g.value; });
    return cents(t);
  }

  function pickDefault() {
    var flagged = document.querySelector('[data-mm-qty][data-mm-default]');
    if (flagged && D[+flagged.dataset.mmQty]) return +flagged.dataset.mmQty;
    return QTYS[Math.floor(QTYS.length / 2)] || QTYS[0];
  }

  /* A cadencia vem da loja, nunca daqui. Dois formatos chegam no `every`:
       - o Kaching publica um JSON  {"delivery":{"interval":"MONTH","frequency":3},...}
       - outros apps publicam texto  "3 months"
     Os dois caem aqui. Sem casar nenhum, devolve null e a data some do texto —
     nunca imprime o cru na tela. Medido em 17/09/2026, com os planos reais. */
  function cadencia(plan) {
    if (!plan) return null;
    var bruto = String(plan.every == null ? '' : plan.every);
    if (bruto.charAt(0) === '{') {
      try {
        var j = JSON.parse(bruto), d = j && (j.delivery || j.billing);
        if (d && d.interval) return { n: d.frequency || 1, unidade: String(d.interval).toLowerCase() };
      } catch (e) { /* cai no texto */ }
    }
    var m = /(\d+)\s*(day|week|month|year)/i.exec(bruto) ||
            /(\d+)\s*(day|week|month|year)/i.exec(String(plan.name || ''));
    if (m) return { n: parseInt(m[1], 10), unidade: m[2].toLowerCase() };
    var um = /every\s+(day|week|month|year)/i.exec(String(plan.name || '') + ' ' + bruto);
    if (um) return { n: 1, unidade: um[1].toLowerCase() };
    return null;
  }

  function textoCadencia(plan) {
    var c = cadencia(plan);
    if (c) return c.n === 1 ? 'every ' + c.unidade : 'every ' + c.n + ' ' + c.unidade + 's';
    /* Ultimo recurso: o NOME do plano, que e texto de gente ("Delivery: every 3
       months"). O `every` cru nunca vai para a tela — no Kaching ele e um JSON. */
    return plan && plan.name ? String(plan.name).replace(/^\s*delivery\s*:\s*/i, '') : '';
  }

  function texto(el, t) { if (el) el.textContent = t; }

  /* ---- Cards empilhados (07/10/2026, modelo da SP Nutrition) -------------
     Cada card mostra, embaixo do preco, uma linha por beneficio: um por brinde
     (foto, valor riscado, FREE), o frete e a garantia. Tudo lido da loja: nome,
     foto e valor do brinde vem do `#lp-gift-data`; frete, do mapa de frete do
     produto que o card vende (assinatura ou avulso). */
  var ICO = {
    frete: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>',
    garantia: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l7 3v6c0 4.4-3 8.1-7 9-4-.9-7-4.6-7-9V6l7-3z"/><path d="M9 12l2 2 4-4"/></svg>',
    semFrete: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/><path d="M2 3l20 18"/></svg>',
    cadeado: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>',
    renova: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 12a9 9 0 1 1-3-6.7L21 8"/><path d="M21 3v5h-5"/></svg>',
    brinde: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 12v9H4v-9M2 7h20v5H2zM12 22V7M12 7H7.5a2.5 2.5 0 1 1 0-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 1 0 0-5C13 2 12 7 12 7z"/></svg>'
  };

  function freteDe(q) { var k = subDe(q) ? D[q] : (O[q] || D[q]); return k ? k.ship : 0; }

  function tituloDe(q) {
    var potes = q + ' ' + (q === 1 ? UN1 : UNN);
    var gs = brindesDe(q);
    if (!subDe(q)) return 'Buy ' + potes;
    if (!gs.length) return 'Get ' + potes;
    return 'Get ' + potes + ' + ' + (gs.length === 1 ? 'Free Gift' : gs.length + ' Free Gifts');
  }

  function linha(classe, icone, rotulo, nota, valor, riscado) {
    var row = document.createElement('span');
    row.className = 'pk-row' + (classe ? ' ' + classe : '');
    var ri = document.createElement('span');
    ri.className = 'ri';
    if (icone && icone.img) {
      var im = document.createElement('img');
      im.src = icone.img; im.alt = ''; im.width = 34; im.height = 34; im.loading = 'lazy';
      ri.appendChild(im);
    } else {
      ri.innerHTML = icone || '';
    }
    row.appendChild(ri);
    var rl = document.createElement('span');
    rl.className = 'rl';
    var b = document.createElement('b'); b.textContent = rotulo; rl.appendChild(b);
    if (nota) { var sm = document.createElement('small'); sm.textContent = nota; rl.appendChild(sm); }
    row.appendChild(rl);
    if (valor) {
      var rv = document.createElement('span');
      rv.className = 'rv';
      if (riscado) { var w = document.createElement('s'); w.textContent = riscado; rv.appendChild(w); }
      if (valor === 'FREE') {
        var fr = document.createElement('span'); fr.className = 'free'; fr.textContent = valor; rv.appendChild(fr);
      } else { rv.appendChild(document.createTextNode(valor)); }
      row.appendChild(rv);
    }
    return row;
  }

  function renderLinhas(card, q) {
    var box = card.querySelector('[data-mm-rows]');
    if (!box) return;
    box.innerHTML = '';
    brindesDe(q).forEach(function (g) {
      box.appendChild(linha('gift', g.img ? { img: g.img } : ICO.brinde,
        'Free ' + g.name, g.note, 'FREE', g.value > 0 ? usd(g.value) : ''));
    });
    var f = freteDe(q);
    if (!(f > 0)) box.appendChild(linha('', ICO.frete, 'Free & Fast Shipping', '', '', ''));
    else if (SEM_FRETE_GRATIS) box.appendChild(linha('nofree', ICO.semFrete, 'No Free Shipping', '', '', ''));
    else if (!SEM_FRETE_PAGO) box.appendChild(linha('', ICO.frete, 'Shipping ' + usd(f), '', '', ''));
    box.appendChild(linha('', ICO.garantia, (GARANTIA[q] || 90) + '-Day Money-Back Guarantee', '', '', ''));
  }

  /* Barra "Gifts unlocked" (modelo Resilia): o frete gratis (quando algum
     pack de assinatura paga frete) e cada brinde, na ordem em que destravam.
     Aceso = o pack escolhido ja leva; apagado = "Unlocks at N bottles". */
  function premios() {
    var t = [];
    var pagos = QTYS.filter(function (q) { return D[q] && D[q].ship > 0; });
    var livres = QTYS.filter(function (q) { return D[q] && !(D[q].ship > 0); });
    if (pagos.length && livres.length) {
      t.push({ icone: ICO.frete, rotulo: 'FREE Shipping',
        valor: Math.max.apply(null, pagos.map(function (q) { return D[q].ship; })),
        min: Math.min.apply(null, livres) });
    }
    G.slice().sort(function (a, b) { return a.minQty - b.minQty; }).forEach(function (g) {
      t.push({ img: g.img, icone: ICO.brinde, rotulo: 'FREE ' + (g.short || g.name), valor: g.value, min: g.minQty });
    });
    return t;
  }

  function renderPremios(barra, emSub) {
    var box = barra.querySelector('[data-mm-gb-items]');
    var t = premios();
    barra.hidden = !emSub || !t.length;
    if (!box) return;
    box.innerHTML = '';
    t.forEach(function (p, i) {
      if (i) { var mais = document.createElement('span'); mais.className = 'gb-plus'; mais.textContent = '+'; box.appendChild(mais); }
      var on = qty >= p.min;
      var it = document.createElement('span');
      it.className = 'gb-it ' + (on ? 'is-on' : 'is-off');
      var ic = document.createElement('span');
      ic.className = 'gb-ic';
      if (p.img) { var im = document.createElement('img'); im.src = p.img; im.alt = ''; im.width = 48; im.height = 48; im.loading = 'lazy'; ic.appendChild(im); }
      else ic.innerHTML = p.icone;
      if (!on) { var lk = document.createElement('span'); lk.className = 'gb-lock'; lk.innerHTML = ICO.cadeado; ic.appendChild(lk); }
      it.appendChild(ic);
      if (p.valor > 0) { var w = document.createElement('s'); w.textContent = usd(p.valor); it.appendChild(w); }
      var b = document.createElement('b'); b.textContent = p.rotulo; it.appendChild(b);
      if (!on) { var sm = document.createElement('small'); sm.textContent = 'Unlocks at ' + p.min + ' ' + UNN.toLowerCase(); it.appendChild(sm); }
      box.appendChild(it);
    });
  }

  function render() {
    var d = ativo(qty);
    if (!d) return;
    var emSub = modoSub();

    document.querySelectorAll('[data-mm-qty]').forEach(function (card) {
      var q = +card.dataset.mmQty, k = ativo(q);
      card.setAttribute('aria-selected', q === qty);
      if (!k) { card.hidden = true; return; }

      var preco = precoCard(q), cheio = riscadoDe(q);

      var price = card.querySelector('[data-mm-price]');
      if (price) price.textContent = usd(preco);

      var was = card.querySelector('[data-mm-was]');
      var save = card.querySelector('[data-mm-save]');
      var temEconomia = cheio > preco;
      if (was) {
        if (temEconomia) { was.textContent = usd(cheio); was.hidden = false; }
        else { was.hidden = true; }
      }
      if (save) {
        if (temEconomia) {
          save.textContent = 'Save ' + Math.round((1 - preco / cheio) * 100) + '%';
          save.hidden = false;
        } else { save.hidden = true; }
      }

      var per = card.querySelector('[data-mm-per]');
      if (per) per.textContent = SUPPLY ? q + (q === 1 ? ' Month Supply' : ' Months Supply') : usd(preco / q) + ' a ' + UN1.toLowerCase();

      texto(card.querySelector('[data-mm-title]'), tituloDe(q));
      renderLinhas(card, q);
      /* Etiqueta verde no canto do card: quantos brindes o pack leva. */
      var gtag = card.querySelector('[data-mm-gifttag]');
      if (gtag) {
        var ng = brindesDe(q).length;
        gtag.textContent = ng ? '\uD83C\uDF81 ' + (ng === 1 ? 'Free Gift' : ng + ' Free Gifts') : '';
        gtag.hidden = !ng;
      }
    });

    var saving = document.getElementById('mm-saving');
    if (saving) {
      var eco = emSub ? economiaTotal(qty) : 0;
      saving.hidden = !(eco > 0);
      texto(saving.querySelector('[data-mm-saving]'), eco > 0 ? usd(eco) : '');
    }

    var barra = document.getElementById('mm-giftsbar');
    if (barra) renderPremios(barra, emSub);

    /* Linha curta da assinatura (modelo Resilia): quando existe, ela substitui
       o bloco `#mm-subinfo`, que fica escondido. */
    var linhaSub = document.getElementById('mm-subline');
    if (linhaSub) {
      var cadL = emSub ? textoCadencia(D[qty].plan) : '';
      linhaSub.hidden = !emSub;
      linhaSub.innerHTML = '';
      if (emSub) {
        var icL = document.createElement('span'); icL.innerHTML = ICO.renova; linhaSub.appendChild(icL.firstChild || icL);
        var txL = document.createElement('span');
        txL.textContent = 'Refills ship ' + (cadL || 'every month') + ' \u00b7 Cancel anytime';
        linhaSub.appendChild(txL);
      }
    }

    var info = document.getElementById('mm-subinfo');
    if (info) {
      info.hidden = !emSub || !!linhaSub;
      var cad = info.querySelector('[data-mm-cadence]');
      if (cad) {
        var t = emSub ? textoCadencia(D[qty].plan) : '';
        cad.textContent = t ? 'Refilled ' + t : '';
      }
      /* O check do frete da assinatura: so diz "every order" quando os tres
         packs de assinatura saem de graca (sub5); senao, os packs que saem. */
      var sf = info.querySelector('[data-mm-subship]');
      if (sf) {
        var livres = QTYS.filter(function (q) { return D[q] && !D[q].ship; });
        sf.textContent = (livres.length === QTYS.filter(function (q) { return D[q]; }).length
          ? 'Free shipping on every subscription order'
          : 'Free shipping on ' + livres.join(' and ') + ' ' + UNN.toLowerCase())
          + ' \u00b7 Skip, pause or cancel anytime';
      }
      /* O link da compra unica: preco avulso da MESMA quantidade do card
         selecionado, e o frete dele quando houver. */
      var once = document.getElementById('mm-once');
      if (once) {
        var o = O[qty];
        once.hidden = !o || !emSub;
        texto(once.querySelector('[data-mm-once-price]'), o ? usd(o.once) : '');
        texto(once.querySelector('[data-mm-once-ship]'), o && o.ship > 0 ? '+ ' + usd(o.ship) + ' shipping' : '');
        once.disabled = !(o && o.avail);
      }
    }

    var btn = document.getElementById('mm-buy');
    if (btn) {
      var total = precoPago(qty);
      var cheioBtn = riscadoDe(qty);
      btn.innerHTML = '';
      btn.appendChild(document.createTextNode('ADD TO CART · ' + usd(total)));
      if (cheioBtn > total) {
        var s = document.createElement('span');
        s.className = 'was';
        s.textContent = usd(cheioBtn);
        btn.appendChild(s);
      }
      btn.disabled = !d.avail;
    }

    var note = document.getElementById('mm-ship');
    if (note) {
      /* Assinando: o frete da assinatura (gratis nos tres hoje). Sem plano: o
         do avulso, com os packs gratis lidos da loja — nunca escritos aqui. */
      var fonte = emSub ? D : O;
      var gratis = QTYS.filter(function (q) { return fonte[q] && !fonte[q].ship; })
        .sort(function (x, y) { return x - y; });
      note.innerHTML = d.ship > 0
        ? 'Shipping ' + usd(d.ship) + (gratis.length
            ? ' — <b>free on ' + gratis.join(' and ') + ' ' + UNN.toLowerCase() + '</b>' : '')
        : '<b>Free US shipping</b> on this order';
    }
  }

  function say(msg) {
    var el = document.getElementById('mm-err');
    if (el) { el.textContent = msg; el.hidden = false; }
  }

  /* Propriedades de linha. Desde 07/10/2026 (pedido do Matheus, checkout no
     modelo das referencias) todas OCULTAS ("_"): o resumo do checkout mostra so
     o produto, a variante e a linha do plano ("Delivery: every month"). Os
     valores continuam gravados no pedido, para o suporte. A linha
     "Subscription" saiu de vez: repetia a do plano. */
  function oferta(avulsa) {
    var props = {};
    var emSub = modoSub() && !avulsa;
    if (emSub) {
      var eco = economiaPack(qty);
      if (eco > 0) props['_you_save'] = usd(eco) + (ANCORA === 'compare' ? ' off the regular price' : ' vs one-time');
    }
    props['_guarantee'] = (GARANTIA[qty] || 90) + '-day money-back guarantee';
    /* Oculta (o "_" esconde no checkout e no e-mail): separa os pedidos desta
       pagina dos das outras na Shopify. */
    props['_pagina'] = PAGINA;
    return props;
  }

  function linhaBrinde(g) {
    var props = {};
    var v = g.value > 0 ? usd(g.value) + ' value' : 'Free';
    props['Free gift'] = g.note ? v + ' · ' + g.note : v;
    props['_pagina'] = PAGINA;
    return { id: g.variantId, quantity: 1, properties: props };
  }

  function adicionar(items) {
    var cs = typeof window !== 'undefined' && window.carrinhoSubstitui;
    if (cs) return cs.adicionar(items);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.ok ? r.json() : r.json().then(function (e) { throw e; }); });
  }

  /* `avulsa` = veio do link BUY ONCE: variante do produto de compra unica,
     sem plano e sem brinde. Senao, a do botao principal (assinatura + brindes
     do pack, quando ha plano). Tudo num `adicionar` so: o carrinhoSubstitui
     esvazia, adiciona e confere contra a lista inteira. */
  function buy(ev, avulsa) {
    if (ev) ev.preventDefault();
    var d = avulsa ? O[qty] : ativo(qty);
    if (!d) return say('Pick a bundle');

    var alvo = document.getElementById(avulsa ? 'mm-once' : 'mm-buy');
    if (alvo) alvo.setAttribute('aria-busy', 'true');

    var item = { id: d.variantId, quantity: 1, properties: oferta(avulsa) };
    var items = [item];
    if (!avulsa && modoSub()) {
      item.selling_plan = D[qty].plan.id;
      brindesDe(qty).forEach(function (g) { items.push(linhaBrinde(g)); });
    }

    adicionar(items)
      .then(function () { window.location.href = '/checkout'; })
      .catch(function (e) {
        if (alvo) alvo.removeAttribute('aria-busy');
        console.error('[brainmag-sub5] /cart/add.js falhou', e);
        say((e && e.description) || 'Could not add to cart — try again');
      });
  }

  /* ---- RedTrack: viewcontent --------------------------------------------
     O `events.js` do RedTrack so manda viewcontent quando acha
     `<form action="/cart/add">` na pagina ou quando o ULTIMO pedaco da URL e
     handle de produto (ele busca `/products/<pedaco>.json`). A sub e a PDP B
     passam por coincidencia de nome (`brain-magnesium-sub` e `brain-magnesium`
     sao produtos); aqui `/products/brain-magnesium-sub2.json` da 404 e o
     evento nao saia. Medido em 24/09/2026.

     Form nao serve: e onde o widget do Kaching se injeta. Entao a pagina manda
     o MESMO que o events.js mandaria: GET no /postback com type=viewcontent e
     eventid = clickid (o RedTrack recusa o repetido, entao disparo duplo nao
     conta duas vezes), e o `__clickid` gravado no carrinho. O host vem da tag
     do proprio events.js, nunca escrito aqui.
     -------------------------------------------------------------------------- */
  function redtrackViewContent(tentativa) {
    var tag = document.querySelector('script[src*="/events.js"]');
    if (!tag || !tag.src) return;
    var host = tag.src.split('/').slice(0, 3).join('/');
    var id = null;
    var m = /(?:^|; )rtkclickid-store=([^;]*)/.exec(document.cookie || '');
    if (m) id = decodeURIComponent(m[1]);
    if (!id || id === 'undefined') {
      try { id = window.sessionStorage.getItem('rtkclickid'); } catch (e) { id = null; }
    }
    if (!id || id === 'undefined') {
      /* o clickid chega pelo unilpclick.js, que pode demorar; o events.js
         tenta a cada 1 s. Aqui com teto de 30 s. */
      if ((tentativa || 0) < 30) setTimeout(function () { redtrackViewContent((tentativa || 0) + 1); }, 1000);
      return;
    }
    var x = new XMLHttpRequest();
    x.open('GET', host + '/postback?clickid=' + encodeURIComponent(id) +
      '&type=viewcontent&eventid=' + encodeURIComponent(id));
    x.send();
    var c = new XMLHttpRequest();
    c.open('POST', '/cart/update.js');
    c.setRequestHeader('Content-Type', 'application/json');
    c.send(JSON.stringify({ attributes: { '__clickid': id } }));
  }

  /* ---- Galeria: slides, nao troca de src, para o srcset do beneo-img valer --
     Com 8 imagens (02/09/2026, antes 6) a miniatura sozinha nao da conta: no
     celular a fila rola de lado e as ultimas ficam fora da tela, entao quem so
     olha nem descobre que ha mais imagem. Dai as setas, o contador e o arrasto.
     -------------------------------------------------------------------------- */
  function gallery() {
    var slides = document.querySelectorAll('[data-mm-slide]');
    var thumbs = document.querySelectorAll('[data-mm-thumb]');
    var strip = document.querySelector('.thumbs');
    var count = document.querySelector('[data-mm-count]');
    var prev = document.querySelector('[data-mm-prev]');
    var next = document.querySelector('[data-mm-next]');
    var main = document.querySelector('.gallery-main');
    if (!slides.length) return;

    var at = 0;

    function show(i) {
      at = (i + slides.length) % slides.length;   /* circula nas duas pontas */
      slides.forEach(function (s, n) { s.setAttribute('data-on', n === at ? '1' : '0'); });
      thumbs.forEach(function (t, n) { t.setAttribute('aria-selected', n === at); });
      if (count) count.textContent = (at + 1) + ' / ' + slides.length;

      /* Centraliza a miniatura ativa na fila. So mexe no scroll HORIZONTAL da
         propria fila — scrollIntoView aqui arrastaria a pagina inteira. */
      var t = thumbs[at];
      if (t && strip && strip.scrollWidth > strip.clientWidth + 2) {
        strip.scrollTo({
          left: Math.max(0, t.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2),
          behavior: 'smooth'
        });
      }
    }

    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { show(n); }); });
    if (prev) prev.addEventListener('click', function () { show(at - 1); });
    if (next) next.addEventListener('click', function () { show(at + 1); });

    /* Arrastar o dedo na imagem grande. Os 40 px de folga e a comparacao com o
       eixo Y existem para nao roubar o scroll de quem so esta descendo a pagina. */
    if (main) {
      var x0 = null, y0 = 0;
      main.addEventListener('touchstart', function (e) {
        x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
      }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        var dy = e.changedTouches[0].clientY - y0;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(at + (dx < 0 ? 1 : -1));
        x0 = null;
      }, { passive: true });
    }

    show(0);
  }

  /* ---- Contagem regressiva do topo ----------------------------------------
     Sessao, nao data: um prazo real que expirasse deixaria a barra em 00:00:00
     no dia seguinte, que e pior do que nao ter barra. Reinicia a cada visita. */
  function timer() {
    var box = document.getElementById('mm-timer');
    if (!box) return;
    var left = (parseInt(box.dataset.minutes, 10) || 10) * 60;
    var h = box.querySelector('[data-t-h]'),
        m = box.querySelector('[data-t-m]'),
        s = box.querySelector('[data-t-s]');
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      if (left <= 0) { left = (parseInt(box.dataset.minutes, 10) || 10) * 60; }
      if (h) h.textContent = pad(Math.floor(left / 3600));
      if (m) m.textContent = pad(Math.floor(left / 60) % 60);
      if (s) s.textContent = pad(left % 60);
      left--;
    }
    tick();
    setInterval(tick, 1000);
  }

  function init() {
    /* A mesma section serve sub5, sub6 e sub7 (07/10/2026): o nome da pagina
       vem do `data-mm-pagina` do container dos cards. */
    var cont = document.querySelector('[data-mm-pagina]');
    if (cont && cont.getAttribute && cont.getAttribute('data-mm-pagina')) PAGINA = cont.getAttribute('data-mm-pagina');
    if (cont && cont.getAttribute) {
      String(cont.getAttribute('data-mm-garantia') || '').split(',').forEach(function (par) {
        var kv = par.split(':'), k = parseInt(kv[0], 10), v = parseInt(kv[1], 10);
        if (k && v) GARANTIA[k] = v;
      });
      SUPPLY = cont.getAttribute('data-mm-supply') === '1';
      if (cont.getAttribute('data-mm-ancora') === 'compare') ANCORA = 'compare';
      SEM_FRETE_PAGO = cont.getAttribute('data-mm-sem-frete-pago') === '1';
      SEM_FRETE_GRATIS = cont.getAttribute('data-mm-sem-frete-gratis') === '1';
    }
    gallery();
    timer();
    redtrackViewContent(0);
    var un = lerJson('mm-unidade');
    if (un && un.one && un.many) { UN1 = un.one; UNN = un.many; }
    if (!read()) return;
    qty = pickDefault();
    sub = temPlano();
    document.querySelectorAll('[data-mm-qty]').forEach(function (card) {
      card.addEventListener('click', function () { qty = +card.dataset.mmQty; render(); });
    });
    var b = document.getElementById('mm-buy');
    if (b) b.addEventListener('click', function (e) { buy(e, false); });
    var o = document.getElementById('mm-once');
    if (o) o.addEventListener('click', function (e) { buy(e, true); });
    if (typeof window !== 'undefined' && window.addEventListener) {
      window.addEventListener('pageshow', function (e) {
        if (!e.persisted) return;
        if (b) b.removeAttribute('aria-busy');
        if (o) o.removeAttribute('aria-busy');
      });
    }
    render();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
